<script setup lang="ts">
</script>

<template>
  <div class="flex items-center justify-center p-4 w-screen h-screen bg-gradient-to-br from-primary-300 to-primary-500">
    <div class="w-full max-w-80">
      <app-router-view />
    </div>
  </div>
</template>
